import { authenticateUser } from '../../services/AuthenticationService.js';

export const AUTHENTICATION_INITIATED = 'AUTHENTICATION_INITIATED';
export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';
export const AUTHENTICATION_SUCCEEDED = 'AUTHENTICATION_SUCCEEDED';

export const initiateAuthentication = () => ({
  type: AUTHENTICATION_INITIATED
});

export const flagAuthenticationFailure = () => ({
  type: AUTHENTICATION_FAILED
});

export const flagAuthenticationSuccess = () => ({
  type: AUTHENTICATION_SUCCEEDED
});

export function login(username, password) {
	console.log("starting login process");
	return (dispatch) => {
		console.log("dispatching login process");
		dispatch(initiateAuthentication());
		authenticateUser(username, password).then(result => {
			result
		  ? dispatch(flagAuthenticationSuccess())
		  : dispatch(flagAuthenticationFailure())
		});
	}
}



// WEBPACK FOOTER //
// ./state/actions/AuthenticationActions.js